import { formatarCelulaLancamento } from "../utils/formatarCelulaLancamento.util";
import styles from "../../Detalhe/detalhe.styles.module.css";

const PAGE_SIZES = [10, 50, 100];

/**
 * @param {object} props
 * @param {Array} props.colunas
 * @param {Array<Record<string, unknown>>} props.linhas
 * @param {{pagina:number,limite:number,total:number,totalPaginas:number}} props.paginacao
 * @param {boolean} props.loading
 * @param {(pagina:number) => void} props.onPageChange
 * @param {(limite:number) => void} props.onPageSizeChange
 */
export default function TabelaLancamentos({
  colunas,
  linhas,
  paginacao,
  loading,
  onPageChange,
  onPageSizeChange,
}) {
  const { pagina = 1, limite = 10, total = 0, totalPaginas = 0 } = paginacao || {};
  const start = total > 0 ? (pagina - 1) * limite + 1 : 0;
  const end = total > 0 ? Math.min(pagina * limite, total) : 0;

  if (!colunas?.length) {
    return <p className={styles.emptyMsg}>Carregando colunas…</p>;
  }

  return (
    <>
      <div className={styles.lancTableWrap}>
        <table className={styles.lancTable}>
          <thead>
            <tr>
              {colunas.map((col) => (
                <th
                  key={col.id}
                  scope="col"
                  className={col.num ? styles.num : undefined}
                  title={col.label}
                >
                  {col.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={colunas.length} className={styles.lancLoadingCell}>
                  Carregando lançamentos…
                </td>
              </tr>
            ) : !linhas?.length ? (
              <tr>
                <td colSpan={colunas.length} className={styles.lancLoadingCell}>
                  Nenhum lançamento encontrado com os filtros.
                </td>
              </tr>
            ) : (
              linhas.map((row, idx) => (
                <tr key={`${row.registro || ""}-${row.dtEmissao || ""}-${idx}`}>
                  {colunas.map((col) => {
                    const texto = formatarCelulaLancamento(col, row);
                    const tdClass = [
                      col.num ? styles.num : "",
                      col.cell === "mono" ? styles.mono : "",
                      col.id === "descricaoContabil" ? styles.lancCellWrap : "",
                    ]
                      .filter(Boolean)
                      .join(" ");
                    return (
                      <td key={col.id} className={tdClass || undefined} title={texto}>
                        {texto}
                      </td>
                    );
                  })}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {total > 0 && (
        <div className={styles.paginationBar}>
          <span className={styles.paginationInfo}>
            Mostrando {start}–{end} de {total.toLocaleString("pt-BR")} lançamento
            {total !== 1 ? "s" : ""} · página {pagina} de {totalPaginas || 1}
          </span>
          <div className={styles.paginationControls}>
            <label htmlFor="lancPageSize">Itens por página</label>
            <select
              id="lancPageSize"
              className={styles.pageSizeSelect}
              value={limite}
              onChange={(e) => onPageSizeChange(Number(e.target.value))}
            >
              {PAGE_SIZES.map((n) => (
                <option key={n} value={n}>
                  {n}
                </option>
              ))}
            </select>
            <button
              type="button"
              className={styles.btnPage}
              disabled={pagina <= 1 || loading}
              onClick={() => onPageChange(pagina - 1)}
            >
              Anterior
            </button>
            <button
              type="button"
              className={styles.btnPage}
              disabled={pagina >= totalPaginas || loading}
              onClick={() => onPageChange(pagina + 1)}
            >
              Próxima
            </button>
          </div>
        </div>
      )}
    </>
  );
}
